export default "__VITE_ASSET__c0gp5m8S__"